// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EbsOG","day":"styles_day__PPTOi","singleDate":"styles_singleDate__jNqJt","currentDate":"styles_currentDate__MGnKM"};